// extracted by mini-css-extract-plugin
export default {"root":"NewsTab_root__Dqb9N","active":"NewsTab_active__4w3xA","disabled":"NewsTab_disabled__h8hhZ"};